/**
 * @desc 通过sku列表获取sku供应商信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuVendorRpcRequestDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getVendorBySkuNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
